// extracted by mini-css-extract-plugin
export var fullWidthButton = "_ew-0";